var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-layout" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _vm.submitSuccess
              ? _c("panel-info-box", [
                  _c("img", {
                    staticStyle: { "max-height": "48px" },
                    attrs: {
                      src: require("../assets/images/icons/checkmark-circle.svg"),
                    },
                  }),
                  _c("p", { staticClass: "text-lg" }, [
                    _c("b", [_vm._v("Dane zostały poprawnie zapisane")]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("panel-competition-form-box", [
                    _c("div", { staticClass: "row w100 mat24" }, [
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("p", { staticClass: "form-input__label" }, [
                          _vm._v("Ustaw kolor podstawowy"),
                        ]),
                        _c("div", { staticClass: "form-input__colorpicker" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.colourDefault,
                                expression: "form.colourDefault",
                              },
                            ],
                            attrs: { id: "coloris" },
                            domProps: { value: _vm.form.colourDefault },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.form,
                                  "colourDefault",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-12 col-lg-5" }, [
                        _c("div", { staticClass: "malr24" }, [
                          _c("p", { staticClass: "form-input__helper" }, [
                            _vm._v(
                              " Dostosuj wygląd systemu do własnych upodobań. Ustaw kolor podstawowy oraz kolor rozszerzony i dodaj własne logo. Dzięki temu zintegrujesz wizualnie nasz system ze swoim kolorami firmowymi. "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("panel-competition-form-box", { staticClass: "mat16" }, [
                    _c("div", { staticClass: "row w100 mat24" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-6" },
                        [
                          _c("p", { staticClass: "form-input__label" }, [
                            _vm._v(
                              "Dodaj logo swojej imprezy (plik jpg lub png)"
                            ),
                          ]),
                          _c("base-input-file", {
                            staticClass: "mat8",
                            attrs: {
                              "is-multiple": false,
                              converter: "base64",
                              accept: "image/png, image/jpeg, image/jpg",
                              hint: "Wybierz plik",
                            },
                            model: {
                              value: _vm.logo,
                              callback: function ($$v) {
                                _vm.logo = $$v
                              },
                              expression: "logo",
                            },
                          }),
                          _vm.form.logoLink
                            ? _c(
                                "div",
                                { staticClass: "mat16" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Obecne logo")]
                                  ),
                                  _c("img", {
                                    staticClass: "mab16 layout-preview",
                                    attrs: {
                                      src: _vm.form.logoLink,
                                      alt: _vm.form.logoFilename,
                                    },
                                  }),
                                  _c(
                                    "base-button",
                                    {
                                      attrs: {
                                        btn2: "",
                                        short: "",
                                        loading: _vm.loadingLogo,
                                        disabled:
                                          _vm.loadingLogo ||
                                          _vm.loadingPoster ||
                                          _vm.loading,
                                      },
                                      on: { click: _vm.removeLogo },
                                    },
                                    [_vm._v("Usuń plik")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("panel-competition-form-box", { staticClass: "mat16" }, [
                    _c("div", { staticClass: "row w100 mat24" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-6" },
                        [
                          _c("p", { staticClass: "form-input__label" }, [
                            _vm._v(
                              "Dodaj plakat swojej imprezy (plik jpg lub png)"
                            ),
                          ]),
                          _c("base-input-file", {
                            staticClass: "mat8",
                            attrs: {
                              "is-multiple": false,
                              converter: "base64",
                              accept: "image/png, image/jpeg, image/jpg",
                              hint: "Wybierz plik",
                            },
                            model: {
                              value: _vm.poster,
                              callback: function ($$v) {
                                _vm.poster = $$v
                              },
                              expression: "poster",
                            },
                          }),
                          _vm.form.posterLink
                            ? _c(
                                "div",
                                { staticClass: "mat16" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Obecny plakat")]
                                  ),
                                  _c("img", {
                                    staticClass: "mab16 layout-preview",
                                    attrs: {
                                      src: _vm.form.posterLink,
                                      alt: "Plakat",
                                    },
                                  }),
                                  _c(
                                    "base-button",
                                    {
                                      attrs: {
                                        btn2: "",
                                        short: "",
                                        loading: _vm.loadingPoster,
                                        disabled:
                                          _vm.loadingPoster ||
                                          _vm.loadingLogo ||
                                          _vm.loading,
                                      },
                                      on: { click: _vm.removePoster },
                                    },
                                    [_vm._v("Usuń plik")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col-12 col-lg-5" }, [
                        _c("div", { staticClass: "malr24" }, [
                          _c("p", { staticClass: "form-input__helper" }, [
                            _vm._v(
                              " Maksymalny rozmiar pliku: 2,5 MB (JPG lub PNG). Wymiary bez sztywnych ograniczeń — najlepiej sprawdzą się plakaty pionowe o proporcjach od 4:5 do 2:3 (szerokość : wysokość). "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-lg-12 mat16 mab64" }, [
                    _c("div", { staticClass: "row justify-content-end" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-4" },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: {
                                btn1: "",
                                loading: _vm.loading,
                                disabled:
                                  _vm.loading ||
                                  _vm.loadingLogo ||
                                  _vm.loadingPoster,
                              },
                              on: { click: _vm.save },
                            },
                            [_vm._v("Zapisz")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }